module.exports = __webpack_public_path__ + "static/media/ami_ja.f8e45f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_ja.png
// module id = 569
// module chunks = 1